import { useRef, useEffect, ReactNode, HTMLAttributes } from "react";
import SmoothScrollbar from "smooth-scrollbar";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
type LayoutProps = {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;
export default function Layout({
  children,
  ...rest
}: LayoutProps & {
  children: ReactNode;
}) {
  let $content = useRef<any>();
  let scrollbar = useRef<any>();
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const el = $content.current;
    scrollbar.current = SmoothScrollbar.init(el, {
      damping: 0.075
    });
    scrollbar.current.setPosition(0, 0);
    scrollbar.current.track.xAxis.element.remove();
    return () => {
      if (scrollbar.current) {
        scrollbar.current.destroy();
        scrollbar.current = null;
      }
    };
  }, []);
  return <div data-scrollbar="true" ref={$content} {...rest} data-sentry-component="Layout" data-sentry-source-file="Scroller.tsx">
      <div>{children}</div>
    </div>;
}